var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"controls-mute",attrs:{"aria-label":_vm.isMuted ? 'Unmute' : 'Mute'},on:{"click":function($event){$event.preventDefault();return _vm.toggleMute($event)}}},[(_vm.isMuted)?_c('IconUnmute'):_c('IconMute')],1)}
var staticRenderFns = []

export { render, staticRenderFns }